import { FC } from 'react';
import { DropdownMenu, Icon, IconButton } from '@kontentino/ui';
import { faArrowDownRight } from '@fortawesome/pro-regular-svg-icons/faArrowDownRight';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { faBarsSort } from '@fortawesome/pro-regular-svg-icons/faBarsSort';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { OrderDirection } from 'app/types';
import { useTranslation } from 'react-i18next';

const SORT_OPTIONS = [
  {
    i18nKey: 'newestToOldest',
    key: OrderDirection.Desc,
    icon: faArrowDownRight,
  },
  {
    i18nKey: 'oldestToNewest',
    key: OrderDirection.Asc,
    icon: faArrowUpRight,
  },
];

type Props = {
  selectedSortOption: OrderDirection;
  onSortOptionSelect: (option: OrderDirection) => void;
  disabled?: boolean;
};

const ApprovalsSortDropdown: FC<Props> = ({
  selectedSortOption,
  onSortOptionSelect,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger disabled={disabled}>
        <IconButton
          size="small"
          variant="secondary"
          disabled={disabled}
          data-name="approvals-sort-button"
          icon={<Icon icon={faBarsSort} />}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="tw-z-10">
        {SORT_OPTIONS.map((sortOption) => (
          <DropdownMenu.Item
            data-name={`approvals-sort-${sortOption.key}`}
            key={sortOption.key}
            onClick={() => onSortOptionSelect(sortOption.key)}
          >
            <Icon icon={sortOption.icon} />
            {t(sortOption.i18nKey)}
            {selectedSortOption === sortOption.key && (
              <span className="tw-ml-auto">
                <Icon icon={faCheck} className="tw-text-primary-100" />
              </span>
            )}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default ApprovalsSortDropdown;
